const types = require('../../constants/actionTypes');


const selected = ({ index }) => ({
    type: types.ASSET_ALLOCATION_SELECTED,
    payload: { index },
});


module.exports = selected;
